import { render } from "./ExamTimetable.vue?vue&type=template&id=08000e53&scoped=true"
import script from "./ExamTimetable.vue?vue&type=script&lang=js"
export * from "./ExamTimetable.vue?vue&type=script&lang=js"

import "./ExamTimetable.vue?vue&type=style&index=0&id=08000e53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08000e53"]])

export default __exports__